import { useAppSelector, useTranslate } from '@common/hooks'
import cx from 'classnames'

import classNames from './styles.module.scss'


interface IProps {
  appId: string,
}
export default function HackathonStatus({
  appId,
}: IProps): JSX.Element | null {
  const { translate } = useTranslate()
  const winners = useAppSelector(store => store.hackathonWinners.winners)

  let winnerPlace = winners?.findIndex(winner => winner.id === appId)
  winnerPlace === undefined && (winnerPlace = -1)
  const isWinner = winnerPlace !== -1

  if(!isWinner) {
    return null
  }
  return (
    <span className={classNames.wrapper}>
      <span className={classNames.status} data-test="app-hackthon-status">
        {translate('Hackathon Winner')}
        <i className={cx(classNames.hackathonWinnersIcon, classNames[`winner${winnerPlace + 1}`])} />
      </span>
    </span>
  )
}
